module.exports = __webpack_public_path__ + "static/media/join-us-banner-md.3f63168e.jpg";